module.exports = __webpack_public_path__ + "static/media/Pr_company.1ac31707.png";